$(document).ready(function () {
  console.log("start!");
  $(".collection_description").on("click", function () {
    console.log("ok!");
    $("#collection_description .description").toggleClass("readmore");
    $(".collection_description span").fadeOut(function () {
      $(".collection_description span")
        .text(
          $(".collection_description span").text() == "Read Less"
            ? "Read More"
            : "Read Less"
        )
        .fadeIn();
    });
  });
  $("#amt_min__price input").on("change", function () {
    var valPrice = parseFloat($(this).val());
    var amt = valPrice.toLocaleString("en-US");
    $("#amt_min__price span").html(amt);
  });
  $("#amt_max__price input").on("change", function () {
    var valPrice = parseFloat($(this).val());
    var amt = valPrice.toLocaleString("en-US");
    $("#amt_max__price span").html(amt);
  });

  // $(window).on("scroll", function () {
  //   const subHeader = $(".product_mini");
  //   const subHeaderPos = subHeader.offset().top;
  //   if ($(window).scrollTop() >= 2100) {
  //     subHeader.addClass("sticky");
  //   } else {
  //     subHeader.removeClass("sticky");
  //   }
  // });

  console.log("end!");
});
